import { wishlistQueries } from '@as-react/common-queries';
import { queryClient } from '@as-react/common-queries';
import { EventEnum, FetchStatus, } from '@as-react/common-types';
import { EventUtil, mergeProductAvailabilitiesToProductLister, mergeProductPricesToProductLister, } from '@as-react/common-utils';
import dayjs from 'dayjs';
import { all, call, fork, getContext, join, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import CategoryAPI from '../../../api/CategoryAPI';
import ProductDetailAPI from '../../../api/ProductDetailAPI';
import WishListApi from '../../../api/wish-list/WishListApi';
import { LOCAL_STORAGE_WISH_LIST_KEY } from '../../../constants/StorageKeysConstants';
import { GeneralActionTypes, ListerActionTypes, MonetateActionTypes, ProductActionTypes, ProductGroupFredhopperTypes, ProductRecentlyViewedActionTypes, SingleProductTileActionTypes, WishListActionTypes, } from '../../../enums/ActionEnums';
import LocalStorageUtil from '../../../util/LocalStorageUtil';
import MonetateUtil from '../../../util/MonetateUtil';
import { isProductOutOfStock } from '../../../util/ProductUtil';
import { isProductInWishList } from '../../../util/WishListUtil';
import { updateCompareProducts } from '../../compare/sagas/CompareSagas';
import { getWishlistStoreData, pushRouterState, replaceRouterState } from '../../router/sagas/RouterSagas';
import { wishListActions } from '../actions/WishListActions.creators';
const WISHLIST_TILES_DEFAULT_COUNT = 30;
export const getCurrentPage = (state) => {
    var _a, _b;
    return parseInt((_b = (_a = state.router.location) === null || _a === void 0 ? void 0 : _a.query) === null || _b === void 0 ? void 0 : _b.page, 10) || 0;
};
export function* getWishListProductsSaga() {
    yield takeLatest(ProductRecentlyViewedActionTypes.FETCH, getWishListProducts);
    yield takeLatest(ListerActionTypes.LISTER_INIT, getWishListProducts);
    yield takeLatest(ProductActionTypes.INIT, getWishListProducts);
    yield takeLatest(SingleProductTileActionTypes.SINGLE_PRODUCT_TILE_INIT, getWishListProducts);
    yield takeLatest(ProductGroupFredhopperTypes.SET_FREDHOPPER_DATA, getWishListProducts);
    yield takeLatest(WishListActionTypes.GET_PRODUCTS, getWishListProducts);
    yield takeLatest(WishListActionTypes.LISTER_INIT, getWishListListerProducts);
    yield takeLatest(WishListActionTypes.LISTER_UPDATE_PAGE, updateWishListPage);
    yield takeLatest(MonetateActionTypes.SET_PRODUCTS, getWishListProducts);
}
export const isTimeStampLastUpdatedValid = (date) => {
    const TIME_UNIT = 'minute';
    const LOCAL_WISH_LIST_EXPIRATION_TIME = 15;
    return dayjs(date).isValid() && dayjs(date).add(LOCAL_WISH_LIST_EXPIRATION_TIME, TIME_UNIT).isAfter(dayjs());
};
export const getWishListProductsFromStore = (state) => state.wishList.products;
export function* getWishListProducts() {
    var _a;
    const { defaultRequestParams, servicesEndpoint, isShopLanding, pageInfo } = yield getContext('aemConfiguration');
    if (isShopLanding) {
        return;
    }
    try {
        if ((pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.isWishlistPage) ||
            (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.isSearchPage) ||
            (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.isCategoryPage) ||
            (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.isPDPPage) ||
            localStorage.getItem(LOCAL_STORAGE_WISH_LIST_KEY) === null ||
            !isTimeStampLastUpdatedValid(JSON.parse(localStorage.getItem(LOCAL_STORAGE_WISH_LIST_KEY)).timeStampLastUpdated)) {
            const { getWishlistProducts } = wishlistQueries({
                servicesEndpoint,
                defaultRequestParams,
            });
            const wishListProducts = yield queryClient.fetchQuery(getWishlistProducts({
                showOutOfStock: !isShopLanding,
            }, { staleTime: 1000 }));
            const localStorageWishList = {
                products: wishListProducts,
                timeStampLastUpdated: new Date(),
            };
            LocalStorageUtil.setItem(LOCAL_STORAGE_WISH_LIST_KEY, localStorageWishList);
            yield put(wishListActions.updateWishListProducts(wishListProducts));
        }
        else {
            const wishListProducts = ((_a = LocalStorageUtil.getJsonItem(LOCAL_STORAGE_WISH_LIST_KEY)) === null || _a === void 0 ? void 0 : _a.products) || [];
            yield put(wishListActions.updateWishListProducts(wishListProducts));
        }
    }
    catch (_b) { }
}
export function* toggleWishListProductSaga() {
    yield takeLatest(WishListActionTypes.TOGGLE_PRODUCT, toggleWishListProduct);
}
export function* toggleWishListProduct(action) {
    var _a, _b;
    try {
        const aemConfigurationContext = yield getContext('aemConfiguration');
        const wishListProducts = yield select(getWishListProductsFromStore);
        const productToSet = action.payload;
        if (isProductInWishList(wishListProducts, productToSet.productId, productToSet.colorId)) {
            yield fork(updateWishListAnalytics, productToSet, WishListActionTypes.ANALYTICS_REMOVE);
            yield fork(removeProductFromWishList, wishListActions.removeProduct(productToSet));
            if (!((_a = aemConfigurationContext.pageInfo) === null || _a === void 0 ? void 0 : _a.isWishlistPage)) {
                yield put(wishListActions.removeProduct(productToSet));
            }
        }
        else {
            yield fork(updateWishListAnalytics, productToSet, WishListActionTypes.ANALYTICS_ADD);
            yield fork(addProductToWishList, wishListActions.addProduct(productToSet));
            if (!((_b = aemConfigurationContext.pageInfo) === null || _b === void 0 ? void 0 : _b.isWishlistPage)) {
                yield put(wishListActions.addProduct(productToSet));
            }
        }
    }
    catch (_c) { }
}
function* updateWishListAnalytics(product, updateType) {
    try {
        const aemConfigurationContext = yield getContext('aemConfiguration');
        const payload = {
            isPDP: aemConfigurationContext.pageInfo.isPDPPage,
            isWishlistPage: aemConfigurationContext.pageInfo.isWishlistPage,
            product,
        };
        yield put({
            type: updateType,
            payload,
        });
    }
    catch (_a) { }
}
export function* addProductToWishList(action) {
    var _a;
    try {
        const { servicesEndpoint, authenticationConfig, pageInfo } = yield getContext('aemConfiguration');
        yield call(WishListApi.addProductToWishList, action.payload, servicesEndpoint, authenticationConfig);
        const localStorageWishList = {
            products: ((_a = LocalStorageUtil.getJsonItem(LOCAL_STORAGE_WISH_LIST_KEY)) === null || _a === void 0 ? void 0 : _a.products) || [],
            timeStampLastUpdated: new Date(),
        };
        localStorageWishList.products.push(action.payload);
        LocalStorageUtil.setItem(LOCAL_STORAGE_WISH_LIST_KEY, localStorageWishList);
        if (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.isWishlistPage) {
            yield put(wishListActions.addProduct(action.payload));
            EventUtil.dispatch(EventEnum.WISHLIST_CHANGED);
        }
    }
    catch (_b) { }
}
export function* removeProductFromWishList(action) {
    var _a;
    try {
        const { servicesEndpoint, authenticationConfig, pageInfo } = yield getContext('aemConfiguration');
        yield call(WishListApi.removeProductFromWishList, action.payload, servicesEndpoint, authenticationConfig);
        const localStorageWishList = {
            products: ((_a = LocalStorageUtil.getJsonItem(LOCAL_STORAGE_WISH_LIST_KEY)) === null || _a === void 0 ? void 0 : _a.products) || [],
            timeStampLastUpdated: new Date(),
        };
        localStorageWishList.products = localStorageWishList.products.filter((product) => product.productId !== action.payload.productId || product.colorId !== action.payload.colorId);
        LocalStorageUtil.setItem(LOCAL_STORAGE_WISH_LIST_KEY, localStorageWishList);
        if (pageInfo === null || pageInfo === void 0 ? void 0 : pageInfo.isWishlistPage) {
            yield put(wishListActions.removeProduct(action.payload));
            EventUtil.dispatch(EventEnum.WISHLIST_CHANGED);
        }
    }
    catch (_b) { }
}
export function* handleWishListLogin() {
    try {
        const { servicesEndpoint, authenticationConfig } = yield getContext('aemConfiguration');
        yield call(WishListApi.login, servicesEndpoint, authenticationConfig);
        yield call(LocalStorageUtil.removeItem, LOCAL_STORAGE_WISH_LIST_KEY);
        yield put(wishListActions.loggedIn());
    }
    catch (_a) {
        yield put(wishListActions.loginFailed());
    }
}
export function* handleWishListLogout() {
    try {
        const { servicesEndpoint, authenticationConfig } = yield getContext('aemConfiguration');
        yield call(WishListApi.logout, servicesEndpoint, authenticationConfig);
        yield call(LocalStorageUtil.removeItem, LOCAL_STORAGE_WISH_LIST_KEY);
        yield put(wishListActions.loggedOut());
    }
    catch (_a) { }
}
function* getWishListCategory(wishListItem) {
    if (!isProductOutOfStock(wishListItem) || !wishListItem.defaultCategoryId) {
        return wishListItem;
    }
    const { servicesEndpoint, defaultRequestParams } = yield getContext('aemConfiguration');
    const category = yield call(CategoryAPI.getById, servicesEndpoint, defaultRequestParams, String(wishListItem.defaultCategoryId));
    return Object.assign(Object.assign({}, wishListItem), { category });
}
function* getWishListAvailability(wishListItems) {
    try {
        const productIds = wishListItems.map(item => item.productId);
        const { servicesEndpoint, defaultRequestParams } = yield getContext('aemConfiguration');
        if (productIds.length > 0) {
            const availabilities = yield call(ProductDetailAPI.getProductAvailabilitiesByProductId, servicesEndpoint, defaultRequestParams.mainWebshop, productIds.join(','));
            if (availabilities) {
                return mergeProductAvailabilitiesToProductLister(wishListItems, availabilities);
            }
        }
    }
    catch (_a) { }
    return wishListItems;
}
export function* getWishListListerProducts() {
    try {
        yield put(wishListActions.setFetchStatus(FetchStatus.PENDING));
        const { isShopLanding, pageInfo, servicesEndpoint, defaultRequestParams } = yield getContext('aemConfiguration');
        const { isWishlistPage } = pageInfo;
        const currentPage = yield select(getCurrentPage);
        const wishlistListerProducts = yield call(WishListApi.getWishlistListerProducts, servicesEndpoint, defaultRequestParams, !isShopLanding ? WISHLIST_TILES_DEFAULT_COUNT : undefined, !isShopLanding ? currentPage : undefined, !isShopLanding);
        const mappedItems = yield all(wishlistListerProducts.items.map(wishlistItem => getWishListCategory(wishlistItem)));
        const itemsWithAvailability = yield call(getWishListAvailability, mappedItems);
        const prices = yield ProductDetailAPI.getAllProductDetailPriceByProductId(mappedItems.map(product => product.productId), servicesEndpoint, defaultRequestParams);
        const itemsWithPrices = itemsWithAvailability.map(product => {
            const productPrice = prices.find(price => product.productId === price.productId);
            return mergeProductPricesToProductLister(product, productPrice);
        });
        yield put(wishListActions.setWishListerListerProducts({
            totalPages: wishlistListerProducts.totalPages,
            itemCount: wishlistListerProducts.itemCount,
            items: itemsWithPrices,
        }));
        yield put(wishListActions.setFetchStatus(FetchStatus.RESOLVED));
        if (isWishlistPage && (itemsWithPrices === null || itemsWithPrices === void 0 ? void 0 : itemsWithPrices.length)) {
            MonetateUtil.pushListerEvent(itemsWithPrices);
        }
    }
    catch (_a) {
        yield put(wishListActions.setFetchStatus(FetchStatus.REJECTED));
        const currentPage = yield select(getCurrentPage);
        if (currentPage > 0) {
            yield put(wishListActions.updateWishListPage({ page: 0, shouldReplaceHistory: true }));
        }
    }
}
export function* updateWishListPage(action) {
    const { page, shouldReplaceHistory } = action.payload;
    const pushingRouterStateTask = yield fork(shouldReplaceHistory ? replaceRouterState : pushRouterState, {
        page,
    });
    yield join(pushingRouterStateTask);
    yield call(getWishListListerProducts);
    yield call(updateCompareProducts);
    const partialRootState = yield select(getWishlistStoreData);
    yield fork(replaceRouterState, { page }, Object.assign({}, partialRootState));
}
export function* wishlistLoginSaga() {
    yield takeLatest(WishListActionTypes.LOGIN, handleWishListLogin);
}
export function* wishlistLogoutSaga() {
    yield takeLatest(WishListActionTypes.LOGOUT, handleWishListLogout);
}
export function* getWishListListerProductsSaga() {
    yield takeLatest(WishListActionTypes.LISTER_GET_PRODUCTS, getWishListListerProducts);
}
function* customEventSaga() {
    yield takeEvery(GeneralActionTypes.CUSTOM_EVENT, handleCustomEvent);
}
function* handleCustomEvent(action) {
    switch (action.payload.eventType) {
        case EventEnum.WISHLIST_CHANGED:
            yield put(wishListActions.getWishListListerProducts());
            yield put(wishListActions.getWishListProducts());
            break;
        default:
            break;
    }
}
export default function* wishListSaga() {
    yield all([
        getWishListProductsSaga(),
        toggleWishListProductSaga(),
        wishlistLoginSaga(),
        wishlistLogoutSaga(),
        getWishListListerProductsSaga(),
        customEventSaga(),
    ]);
}
